export enum SalesTaxFlagCode{
    None = 0,
    AdjustmentNotAccepted = 1,
    AdjustmentAccepted = 2
}